import FileSaver from 'file-saver';
import { ParamValues } from '../../components/Crud/useFilter.types';
import { restApi } from '../../services/api';
import { XLS_FORMAT } from '../../utils/constants';

interface DownloadXlsxParams {
  fileName?: string;
  url: string;
  filters?: ParamValues;
  isStatic?: boolean;
  locale?: string;
}

const downloadStaticFile = (url: string): void => {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadXlsx = ({
  fileName,
  url,
  filters = {},
  isStatic = false,
  locale,
}: DownloadXlsxParams): Promise<void> => {
  if (isStatic) {
    downloadStaticFile(url);
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../webWorkers/excel.worker', import.meta.url), {
      type: 'module',
    });

    const validFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined),
    );

    worker.postMessage({
      url: new URL(url, restApi.getBaseURL()).href,
      params: validFilters,
      headers: locale ? { ...restApi.headers, 'Accept-Language': locale } : restApi.headers,
    });

    worker.onmessage = function (e) {
      const { data, type } = e.data;

      switch (type) {
        case 'complete': {
          const blob = new Blob([data], { type: XLS_FORMAT });
          FileSaver.saveAs(blob, fileName);
          worker.terminate();
          resolve();
          break;
        }

        case 'error': {
          reject(new Error(`Download failed: ${data}`));
          worker.terminate();
          break;
        }

        default:
          break;
      }
    };

    worker.onerror = function (error) {
      reject(error);
      worker.terminate();
    };
  });
};
